// extracted by mini-css-extract-plugin
export default {"host":"style_host__ieV2z","table":"style_table__yQV-u","headerRow":"style_headerRow__Lf2fD","borderLeft":"style_borderLeft__U5htH","borderRight":"style_borderRight__1X9io"};